var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterAlignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04 7.62712H18.96C19.048 7.62712 19.12 7.54576 19.12 7.44633V6.18079C19.12 6.08136 19.048 6 18.96 6H9.04C8.952 6 8.88 6.08136 8.88 6.18079V7.44633C8.88 7.54576 8.952 7.62712 9.04 7.62712ZM18.96 17.209C19.048 17.209 19.12 17.1277 19.12 17.0282V15.7627C19.12 15.6633 19.048 15.5819 18.96 15.5819H9.04C8.952 15.5819 8.88 15.6633 8.88 15.7627V17.0282C8.88 17.1277 8.952 17.209 9.04 17.209H18.96ZM21.84 20.3729H6.16C6.072 20.3729 6 20.4542 6 20.5537V21.8192C6 21.9186 6.072 22 6.16 22H21.84C21.928 22 22 21.9186 22 21.8192V20.5537C22 20.4542 21.928 20.3729 21.84 20.3729ZM21.84 10.791H6.16C6.072 10.791 6 10.8723 6 10.9718V12.2373C6 12.3367 6.072 12.4181 6.16 12.4181H21.84C21.928 12.4181 22 12.3367 22 12.2373V10.9718C22 10.8723 21.928 10.791 21.84 10.791Z",
    fill: "#B4B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlignIcon);
export default __webpack_public_path__ + "static/media/CenterAlignIcon.18be43b1c6a5eeb60970f250e232953e.svg";
export { ForwardRef as ReactComponent };